import MinimumWageRef from './assets/images/minimum_wage_ref.png';
import MrpRef from './assets/images/mrp_ref.png';
import PenaltyCoef from './assets/images/penalty_coef.png';
import RefMsu from './assets/images/ref_msu.png';
import RefundingRate from './assets/images/refunding_rate.png';
import TaxClassification from './assets/images/tax_classification.png';
import TaxOrg from './assets/images/tax_org.png';
import Uploaded from './assets/images/uploaded.png';

export const getCardImages = () => ({
    penalty_coef: {
        name: 'Справочник коэффициентов для расчета пени',
        src: PenaltyCoef,
        path: '/reference-book-penalty-calculation',
    },
    refunding_rate: {
        name: 'Справочник ставок рефинансирования',
        src: RefundingRate,
        path: '/reference-book-refunding-rate',
    },
    tax_classification: {
        name: 'Справочник кодов бюджетной классификации (КБК)',
        src: TaxClassification,
        path: '/reference-book-tax-classification',
    },
    mrp_ref: {
        name: 'Справочник минимальных расчетных показателей (МРП)',
        src: MrpRef,
        path: '/reference-book-minimum-calculated-indicators',
    },
    minimum_wage_ref: {
        name: 'Справочник минимальной заработной платы',
        src: MinimumWageRef,
        path: '/reference-book-minimum-wage',
    },
    tax_org: {
        name: 'Справочник кодов органов государственных доходов Республики Казахстан',
        src: TaxOrg,
        path: '/reference-book-government-revenue',
    },
    ref_msu: {
        name: 'Справочник органов местного самоуправления и органов государственных доходов',
        src: RefMsu,
        path: '/reference-book-local-self-government',
    },


    payment_details: {
        name: 'Справочник (кодификатор) с указанием БИН и реквизитами для зачисления платежей в бюджет по органам государственных доходов Республики Казахстан',
        src: Uploaded,
        path: '/reference-book-payment-details',
        source: 'uploaded',
    },
    taxpayer_codes: {
        name: 'Таблица соответствия КБК, БИК и категории НП',
        src: Uploaded,
        path: '/reference-book-taxpayer-codes',
        source: 'uploaded',
    },
    national_bank_payment_details: {
        name: 'Реквизиты Национального Банка Республики Казахстан для зачисления денег в иностранной валюте на текущие счета Комитета казначейства Министерства финансов Республики Казахстан',
        src: Uploaded,
        path: '/reference-book-national-bank-payment-details',
        source: 'uploaded',
    },
    medical_insurance_payment_details: {
        name: 'Реквизиты по перечислению отчислений и (или) взносов на обязательное социальное медицинское страхование',
        src: Uploaded,
        path: '/reference-book-medical-insurance-payment-details',
        source: 'uploaded',
    },
    uploaded: {
        src: Uploaded,
        source: 'uploaded',
    },
});
